import { Inject, Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class MetaMgmtService {
  constructor(private title: Title, private meta: Meta, @Inject(DOCUMENT) private dom: any) { }

  updateMetaTags(metaData: any) {
    this.title.setTitle(metaData.pageTitle ? metaData.pageTitle : 'Luminouseshop');
    let keys = Object.keys(metaData);
    keys.forEach(element => {
      if (metaData[element]) {
        if (element != 'ogDescription' && element != 'ogTitle' && element != 'ogTitle' && element != 'pageTitle' && element != 'canonicalURL') {
          this.meta.updateTag({ name: element, content: metaData[element] });
        }
        else if (element == 'pageTitle') {
          this.meta.updateTag({ name: 'title', content: metaData[element] });
        }
        else if (element == 'canonicalURL') {
          this.createCanonicalURL(metaData[element]);
        }
        else {
          this.meta.updateTag({ property: element, content: metaData[element] });
        }
      }
      else {
        if (element != 'ogDescription' && element != 'ogTitle' && element != 'ogTitle' && element != 'pageTitle' && element != 'canonicalURL') {
          this.meta.removeTag(`name=${element}`);
        }
        else if (element == 'pageTitle') {
          this.meta.removeTag(`name='title'`);
        }
        else if (element == 'canonicalURL') {
          this.removeCanonicalURL();
        }
        else {
          this.meta.removeTag(`property=${element}`);
        }
      }
    })
    if (!metaData.robots || metaData.robots == 'none') {
      this.meta.updateTag({ name: 'robots', content: 'index,follow' });
    }
  }

  createCanonicalURL(urlToAppend: any) {
    let canocialURLAttr = this.dom.getElementById('canonicalURL');
    if (canocialURLAttr) {
      canocialURLAttr.setAttribute('href', urlToAppend)
    }
    else {
      let link: HTMLLinkElement = this.dom.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('id', 'canonicalURL');
      this.dom.head.appendChild(link);
      link.setAttribute('href', urlToAppend);
    }
  }

  removeCanonicalURL() {
    let canocialURLAttr = this.dom.getElementById('canonicalURL');
    if (canocialURLAttr)
      this.dom.head.removeChild(canocialURLAttr);
  }
}
